module.exports = __webpack_public_path__ + "static/img/waiting-print.436b398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/waiting-print.png
// module id = wL7B
// module chunks = 31